import { executeRequest, JFSRequest } from '@jfs/network'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, sitConfig } from './config'

const responseParser = (response: any) => {
  return response
}

const getBizProgDetailsFromMccCode = (mccCode: string, businessLine: string, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: APIEndPoints.getBizProgDetailsFromMccCode,
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: businessLine?.length > 0 && mccCode?.length === 0 ? { businessLine: businessLine } : { mccCode: mccCode },
  }
  return executeRequest(request)
    .then((data) => {
      return responseParser(data.data)
    })
    .catch((error) => {
      throw error
    })
}

export { getBizProgDetailsFromMccCode }
